export default __webpack_public_path__ + "static/media/notSnapShot.efd87e15.svg";